import { Multicall3 } from 'config/abi/types/Multicall'
import { getMulticallContract } from './contractHelpers'

export type MulticallResponse = Pick<Multicall3.ResultStructOutput, 'success' | 'returnData'>

export const getMulticallResponse = async ({
  chainId,
  calls
}: {
  chainId?: number
  calls: Multicall3.Call3Struct[]
}): Promise<MulticallResponse[]> => {
  const MulticallContract = getMulticallContract(chainId)
  const multicallResults: Multicall3.ResultStructOutput[] = await MulticallContract.callStatic.aggregate3(calls)

  const results: MulticallResponse[] = multicallResults.map((res) => ({
    success: res.success,
    returnData: res.returnData
  }))

  return results
}
